export const getStatisticsRoute = '/statistics/get';
export const getNetWorthRoute = '/statistics/getNetWorth';
